export function baseUrl(){
	let baseUrl = "";
	if (process.env.NODE_ENV === "development") {
		//本地(开发环境)
	    baseUrl = "https://light-word.cn/"
	} else {
		//线上(生产环境)
	    baseUrl = "https://light-word.cn/"
	}
	return baseUrl;
}
